var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.417 3.75c-9.2 0-16.667 7.467-16.667 16.667 0 9.2 7.467 16.666 16.667 16.666 9.2 0 16.666-7.466 16.666-16.666S29.617 3.75 20.417 3.75Zm1.666 25H18.75v-10h3.333v10Zm0-13.333H18.75v-3.334h3.333v3.334Z"
})));
export default SvgInfo;